import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}



export const portalLink = "https://apply.mbg.mn"


export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy text: ', error);
    return false;
  }
}

// make youtube regular video long link to iframe
export const youtubeVideo = (link: string) => {
  const videoId = link.split("v=")[1];
  // Use privacy-enhanced mode to reduce third-party cookies
  return `https://www.youtube-nocookie.com/embed/${videoId}?controls=1&rel=0&playsinline=1&modestbranding=1`;
}

// Detect if the device is Windows
export const isWindows = () => {
  if (typeof window === 'undefined') return false;
  return /Windows/.test(navigator.userAgent);
}

// Conditionally show emoji based on platform
export const showEmoji = (emoji: string, fallback: string = '') => {
  return isWindows() ? fallback : emoji;
}

/**
 * Strip markdown formatting from text
 * Removes headers, bold/italic, links, images, code blocks, etc.
 */
export function stripMarkdown(text: string): string {
  if (!text) return "";
  
  let cleaned = text;
  
  // Remove headers (# ## ### etc.)
  cleaned = cleaned.replace(/^#{1,6}\s+/gm, "");
  
  // Remove bold/italic (**text**, *text*, __text__, _text_)
  cleaned = cleaned.replace(/\*\*([^*]+)\*\*/g, "$1");
  cleaned = cleaned.replace(/\*([^*]+)\*/g, "$1");
  cleaned = cleaned.replace(/__([^_]+)__/g, "$1");
  cleaned = cleaned.replace(/_([^_]+)_/g, "$1");
  
  // Remove links [text](url) -> text
  cleaned = cleaned.replace(/\[([^\]]+)\]\([^\)]+\)/g, "$1");
  
  // Remove images ![alt](url) -> alt
  cleaned = cleaned.replace(/!\[([^\]]*)\]\([^\)]+\)/g, "$1");
  
  // Remove inline code `code` -> code
  cleaned = cleaned.replace(/`([^`]+)`/g, "$1");
  
  // Remove code blocks ```code``` -> code
  cleaned = cleaned.replace(/```[\s\S]*?```/g, "");
  
  // Remove blockquotes (> text)
  cleaned = cleaned.replace(/^>\s+/gm, "");
  
  // Remove list markers (-, *, +, 1., etc.)
  cleaned = cleaned.replace(/^[\s]*[-*+]\s+/gm, "");
  cleaned = cleaned.replace(/^[\s]*\d+\.\s+/gm, "");
  
  // Remove horizontal rules
  cleaned = cleaned.replace(/^---+/gm, "");
  cleaned = cleaned.replace(/^\*\*\*+/gm, "");
  
  // Remove strikethrough ~~text~~ -> text
  cleaned = cleaned.replace(/~~([^~]+)~~/g, "$1");
  
  // Clean up extra whitespace
  cleaned = cleaned.replace(/\n{3,}/g, "\n\n");
  cleaned = cleaned.trim();
  
  return cleaned;
}